import React from 'react';
import Label from '../../shared/components/I18n/Label';
import CmdLink from '../../shared/components/CmdLink';
import SignUpLink from '../../shared/components/SignUp/SignUpLink';

const UnauthenticatedButtons = ({ signUpClick }) => (
  <>
    <CmdLink className='btn btn-login' cmd='signin'>
      <Label message='login' />
    </CmdLink>
    <SignUpLink onClickHandler={signUpClick} />
  </>
);

export default UnauthenticatedButtons;
